/**
 * @generated SignedSource<<f7a902513a84cfeb3c70bed044430d36>>
 * @relayHash 6df71af5b18205c2d07f80f9026e85c3
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6df71af5b18205c2d07f80f9026e85c3

import { ConcreteRequest } from 'relay-runtime';
export type RegisterVisitorPortfolioProjectViewEventInput = {
  currentUrl?: any | null;
  portfolioProjectId: string;
  referrerUrl?: any | null;
};
export type useSendAnalyticEventMutationPortfolioProjectViewEventMutation$variables = {
  input: RegisterVisitorPortfolioProjectViewEventInput;
};
export type useSendAnalyticEventMutationPortfolioProjectViewEventMutation$data = {
  readonly registerVisitorPortfolioProjectViewEvent: {
    readonly registered: boolean;
  };
};
export type useSendAnalyticEventMutationPortfolioProjectViewEventMutation = {
  response: useSendAnalyticEventMutationPortfolioProjectViewEventMutation$data;
  variables: useSendAnalyticEventMutationPortfolioProjectViewEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RegisterVisitorPortfolioProjectViewEventPayload",
    "kind": "LinkedField",
    "name": "registerVisitorPortfolioProjectViewEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "registered",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSendAnalyticEventMutationPortfolioProjectViewEventMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSendAnalyticEventMutationPortfolioProjectViewEventMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "6df71af5b18205c2d07f80f9026e85c3",
    "metadata": {},
    "name": "useSendAnalyticEventMutationPortfolioProjectViewEventMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f4e777e567d7c5554128ab3964c83ad0";

export default node;
